import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { ConfigFieldOption } from '@/eventConfig/types.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { useForm } from '@/form/useForm.ts';

export const AncestrySummaryFormGB = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['ancestry'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const ancestryField = s.ancestry.fields.find(({ name }) => name === 'ancestry');
  const ancestryLabel = translate(ancestryField?.label);

  // Options are nested in groups, take them out
  const ancestryOptions = (ancestryField?.options || [])
    .reduce((acc, curr) => {
      return [...acc, curr, ...(curr?.items || [])];
    }, [] as ConfigFieldOption[])
    .filter(({ value }) => value !== '');

  const ancestryValue =
    translate(ancestryOptions.find(({ value }) => value === getFieldValue('ancestry'))?.label) ||
    getFieldValue('ancestry');

  return (
    <div className="summary-card" data-cy={'summary-form-ancestry'}>
      <h2>{translate(s.dataSummary.titles?.ancestry)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{ancestryLabel}</div>
        <div className={'value'}>
          {!editMode && ancestryValue}
          {editMode && <EditDataField field={ancestryField!} slideId={'ancestry'} />}
        </div>
      </div>
    </div>
  );
};
